var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title',[_vm._v("兑换礼品券基本信息")]),_vm._v(" "),_c('GoodsGiftInfoTab',{attrs:{"active":_vm.currentTit}}),_vm._v(" "),_c('GoodsInfoPage',{attrs:{"goodsType":1}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91236e60","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/GoodsFolder/GoodsGift/GoodsGiftBasicInfo.vue
// module id = null
// module chunks = 